import { render, staticRenderFns } from "./PercentageInput.vue?vue&type=template&id=8edfb3f4&scoped=true&"
import script from "./PercentageInput.vue?vue&type=script&lang=ts&"
export * from "./PercentageInput.vue?vue&type=script&lang=ts&"
import style0 from "./PercentageInput.vue?vue&type=style&index=0&id=8edfb3f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8edfb3f4",
  null
  
)

export default component.exports